import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Ensure any previously registered service workers are unregistered.
// This prevents stale production caches from interfering with local development.
if ('serviceWorker' in navigator) {
  // In development, always unregister existing workers.
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().catch((err) => {
        console.warn('Service worker unregister failed:', err);
      });
    });
  }).catch((err) => {
    console.warn('Error fetching service worker registrations:', err);
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 